import { __assign, __awaiter, __decorate, __extends, __generator, __metadata, __rest } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { FileContext } from './FileContext';
import { BindPropsHelper } from '../PropTypes';
/**
 * Renders an input[type=file] input bound to a file manager.
 */
var FileBasicInput = /** @class */ (function (_super) {
    __extends(FileBasicInput, _super);
    function FileBasicInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onFileSelected = _this.onFileSelected.bind(_this);
        return _this;
    }
    FileBasicInput.prototype.onFileSelected = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var input;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!e.target.files) return [3 /*break*/, 4];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.fileManager.processFiles(e.target.files, { handleErrors: !this.fileManager.options.taskRunner })];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        input = (_a = e.target) !== null && _a !== void 0 ? _a : (_b = this.props.inputRef) === null || _b === void 0 ? void 0 : _b.current;
                        if (input) {
                            input.value = "";
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FileBasicInput.prototype.render = function () {
        var _a = this.props, fileManager = _a.fileManager, isHidden = _a.isHidden, inputRef = _a.inputRef, native = __rest(_a, ["fileManager", "isHidden", "inputRef"]);
        if (this.context.fileManager) {
            this.fileManager = this.context.fileManager;
        }
        else {
            if (!fileManager) {
                throw Error("Basic file input must be in a FileContext, or have fileManager specified.");
            }
            this.fileManager = fileManager;
        }
        if (!native.name) {
            native.name = this.fileManager.options.name;
        }
        var bindProperty = this.fileManager.options.bind;
        if (bindProperty) {
            // @ts-ignore
            native[BindPropsHelper.DataFieldName] = bindProperty.propertyInfo.propertyName;
        }
        var fileManagerProps = this.fileManager.getFileInputProps();
        return React.createElement("input", __assign({}, fileManagerProps, { ref: inputRef, type: "file", style: { display: isHidden ? "none" : "unset" }, onChange: this.onFileSelected }, native));
    };
    FileBasicInput.contextType = FileContext;
    FileBasicInput = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], FileBasicInput);
    return FileBasicInput;
}(React.Component));
export default FileBasicInput;
